import { ReactNode } from 'react';

export type TAccordionItemButton = {
  children?: ReactNode;
};

export const AccordionItemButton = ({ children }: TAccordionItemButton) => {
  return <>{children}</>;
};
